"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PopularRoute {
    static get path() {
        return '/popular';
    }
    static get friendlyName() {
        return 'popularHeader';
    }
}
exports.default = PopularRoute;
